import React from "react";
import { L10n } from "@fidget/common/i18n";
import { CloserLoaderComponent } from "@fidget/common/components/loader/closerLoader";
import { BeforeLoginSection } from "../components/beforeLoginSection";

interface Props {
  timeout?: number;
}

interface State {
  version: "setUp" | "doNotForgotPicture";
}

export class SetUpSection extends React.Component<Props, State> {
  timeoutID?: number;

  constructor(props: Props) {
    super(props);
    this.state = {
      version: "setUp"
    };
    if (props.timeout) {
      this.timeoutID = window.setTimeout(
        () => this.setState({ version: "doNotForgotPicture" }),
        props.timeout
      );
    }
  }

  componentWillUnmount() {
    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
    }
  }

  render() {
    return (
      <BeforeLoginSection styleType={"signup"}>
        <header>
          <h2>
            {" "}
            <L10n
              id={
                this.state.version === "doNotForgotPicture"
                  ? "signup.doNotForgetPicture"
                  : "signup.gettingSetUp"
              }
            />{" "}
          </h2>
        </header>
        <CloserLoaderComponent signupStyle />
      </BeforeLoginSection>
    );
  }
}
